import { useState } from "react";

export function useFormFields(initialState) {
  const [fields, setFields] = useState(initialState);

  const handleFields = (value, field) => {
    let copiedFields = { ...fields };
    copiedFields[field] = value;
    setFields(copiedFields);
  };

  const resetValues = (fields) =>
    Object.keys(fields).forEach((k) => (fields[k] = ""));
  return { fields, handleFields, resetValues };
}
